module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_data":"データなし"},"en":{"no_data":"No Data"}}')
  delete Component.options._Ctor
}
